import React from 'react';
import styles from './buttons.module.scss';
import classnames from 'classnames'

const PrimaryButton = (props) => {

  const { text, onClick, style, white, className, disabled } = props;

  return (
      <button
        type="button"
        className={classnames(styles.primaryBtn, {[styles.white]: white, [styles.disabled]: disabled}, className)}
        onClick={onClick}
        style={style}
        disabled={(disabled != null) ? disabled : false}
        >
          {text}
        </button>
    );
}

export default PrimaryButton;
